import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.CompanyInfoStep.StepForm', {
    companyName: 'Company name',
    companyNamePlaceholder: 'Enter company name...',
    tradingName: 'Trading name',
    tradingNamePlaceholder: 'Enter trading name...',
    registeredCountry: 'Registered country',
    registeredCountryPlaceholder: 'Registered country...',
    legalEntityName: 'Legal entity type',
    legalEntityNamePlaceholder: 'Select legal entity type',
    registrationDate: 'Registration date',
    registrationDatePlaceholder: 'Enter a date...',
    registrationNumber: 'Registration number',
    registrationNumberPlaceholder: 'Enter registration number...',
    vatNumber: 'VAT number',
    vatNumberPlaceholder: 'Enter VAT number...',
});

export const legalEntityTypeMessages = defineMessages(
    'app.WalletsPage.KycPage.wizard.CompanyInfoStep.StepForm.legalEntityTypes',
    {
        companyWithNomineeShareholdersOrSharesInBearerForm:
            'Company with Nominee Shareholders or Shares in Bearer Form',
        limitedLiabilityCompany: 'Limited Liability Company',
        limitedLiabilityPartnership: 'Limited Liability Partnership',
        other: 'Other',
        publicLimitedCompany: 'Public Limited Company',
        registeredCharity: 'Registered Charity',
        scottishLimitedPartnership: 'Scottish Limited Partnership',
        trust: 'Trust',
        unincorporatedPartnership: 'Unincorporated Partnership',
        unregisteredCharity: 'Unregistered Charity',
    }
);
